import React from 'react';
import './main.scss';
import { Provider } from 'react-redux';
import store from './store/store';
import CustomNavbar from './components/custom-navbar/custom-navbar';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import SettingsView from './views/settings-view/settings-view';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainView from './views/main-view/main-view';
import {withAuthenticator} from '@aws-amplify/ui-react';
import ReactNotification from 'react-notifications-component'
import { Authenticator } from '@aws-amplify/ui-react';


const formFields = {
    signIn: {
      username: {
        placeholder: 'Podaj nazwe urządzenia',
        isRequired: true,
        label: 'Urządzenie'
      },
      password: {
        placeholder: 'Podaj hasło',
        isRequired: true,
        label: 'Hasło'
      },
    },
  }

const App: React.FC = () => {
    return (
        <Provider store={store}>
            <Authenticator hideSignUp={true} formFields={formFields}>
            {() => (
                <BrowserRouter>
                <ReactNotification />
                <CustomNavbar/>
                <Routes>
                    <Route path="/" element={<MainView/>}/>
                    <Route path="settings/*" element={<SettingsView/>}/>
                </Routes>
            </BrowserRouter>
            )}
            </Authenticator>
        </Provider>
    )
}

// export default withAuthenticator(App);
export default App;
